import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchPromptsForAccount, invalidateSeekSession, seekAnswerForQuestion } from '../../redux/actions/seek';

import cx from 'classnames';

import styles from './seek.module.scss';
import { SeekPanel } from '../Seek';
import { useSelector } from 'react-redux';
import { Dataset } from '../../types/dataseek';
import { nanoid } from '@reduxjs/toolkit';
import { translations } from '../../i18n';

interface DataSeekContainerProps {
  account: string;
  dataset: Dataset;
  language: string;
}

export const DataSeekContainer: React.FC<DataSeekContainerProps> = ({ account, dataset, language }) => {
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);


  const querying = useSelector((state: any) => {
    return state.seek.chats?.some((chat: any) => chat.querying);
  });

  const session = useSelector((state: any) => {
    return state.seek.session || null;
  });

  const handleOpen = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleAnswer = (question: any) => {
    dispatch(seekAnswerForQuestion({
      uuid: nanoid(6),
      dataset_id: dataset.id,
      session_id: session,
      question: question.payload as any,
    }));
  }

  const handleNewChat = () => {
    dispatch(invalidateSeekSession(session));
  }

  return (
    <div className={cx(styles.seekPanel)}>
      <SeekIndicator onClick={(handleOpen)} />
      <div className={cx(styles.panel, {
        [styles.open]: open,
      })}>
        <button className={styles.closeButton} onClick={handleClose}>
          <img src={`${process.env.IMAGE_CDN_URL}/images/seek/close.svg`} />
        </button>

        <SeekPanel
          open={open}
          dataset={dataset}
          session={session}
          locale={language}
          querying={querying}
          onAnswer={handleAnswer}
          onNewChat={handleNewChat}
          onClose={handleClose}
        />
      </div>
    </div>
  );
}

interface SeekIndicatorProps {
  onClick: () => void;
}

const SeekIndicator: React.FC<SeekIndicatorProps> = ({ onClick }) => {
  return (
    <div className={styles.seekIndicator}>
      <div className={styles.seekTab} onClick={onClick}>
        <div className={styles.wrapper}>
          <img className={styles.arrow} src={`${process.env.IMAGE_CDN_URL}/images/seek/left_arrow.svg`} />
          <div className={styles.details}>
            <div className={styles.heading}>
              <div className={styles.name}>seek</div>
              <img className={styles.logo} src={`${process.env.IMAGE_CDN_URL}/images/seek/logo.svg`} />
            </div>
            <div className={styles.subText}>
              {translations.translation['seek.generative_ai']}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.border}></div>
    </div>
  );
}
